const BRAND_COLOR = "#0625ee"

export function Under() {
  return (
    <div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          padding: 20,
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          pointerEvents: "none",
        }}>
          <div style={{ width: "100%", padding: 0, display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
            <p
              style={{
                fontFamily: "'Antonio', sans-serif",
                height: 30,
                fontSize: 30,
                fontWeight: "700",
                lineHeight: "30px",
                color: BRAND_COLOR,
                letterSpacing: -2,
              }}>
              GERARDO CARA
            </p>
        <p style={{
          flex: "1 1 0%", height: 30,
          fontFamily: "'Antonio', sans-serif",
            fontSize: 16,
            fontWeight: "700",
            lineHeight: "1em",
            textAlign: "right",
            color: BRAND_COLOR,
            letterSpacing: -0.5,
            whiteSpace: "nowrap",
        }}>FRONT END DEVELOPER</p>
      </div>



    </div>
    </div>
  )
}

export function Underlay() {
  return (
    <div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          padding: 20,
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          pointerEvents: "none",
        }}>


      <div
        style={{
          height: "50%",
          fontFamily: "'Antonio', sans-serif",
          width: "100%",
          flex: "1 1 0%",
          padding: 0,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}>
        <p  style={{ flex: "1 1 0%", fontSize: 224, lineHeight: "1em", color: "white", margin: "-26px 0 0 0", textAlign: "center" }}>GERAR</p>


      </div>

    </div>
    </div>
  )
}

export function Overlay() {
  return (
    <div>
      <div style={{ position: "absolute", bottom: 20, right: 10 }}>
        <p style={{ flex: "1 1 0%", fontSize: 12, lineHeight: "1em", textAlign: "right", color: BRAND_COLOR }}>
          <a href="https://ceroonce.com">www.ceroonce.com</a>
        </p>
      </div>
    </div>
  )
}




export function Up() {
  return (

      <div
        style={{
          position: "absolute",
          bottom: 20,
          left: 20,
        }}>
        <div
          style={{
            pointerEvents: "all",
            pointer: "auto",
            padding: 0,
            display: "bottom",
            flexDirection: "row",
            alignItems: "flex-end",
            justifyContent: "center",
          }}>
        <p style={{ whiteSpace: "nowrap", flex: "1 1 0%", fontSize: 12, lineHeight: "1.5em", color: BRAND_COLOR }}>
          <a href="http://wa.me/+5491156414084">+5491156414084</a>
          <br />
          <a href="mailto:gerardo@cara.com.ar">gerardo@cara.com.ar</a>
        </p>

      </div>


      </div>
  )
}

